import React from 'react';
import { observer } from 'mobx-react-lite';
import { FreeBetsWrapper, isMobile, TableUsersWinBets } from '@pascal/pascal-core';
// import video from '../../assets/video/game_video.mp4';
// import PosterVideoBG from '../../assets/images/NoneStopMatch/bg.jpg';
import { FieldsContainer } from '../fieldsContainer';
import { LastResults } from '../../components/lastResults';
// import { EuroSymbol } from '../../components/euroTemplate/euroSymbol';

const GameContent = observer(() => {
  return (
    <div className='none-stop-match'>
      <div className='video-bg' />
      {/* <video */}
      {/*  className='video-bg' */}
      {/*  autoPlay*/}
      {/*  muted*/}
      {/*  loop*/}
      {/*  poster={PosterVideoBG}*/}
      {/*  playsInline*/}
      {/*  onLoadStart={() => console.log('started')}*/}
      {/*  onLoadedData={() => console.log('loaded')}*/}
      {/*>*/}
      {/*  <source src={video} type='video/mp4' />*/}
      {/*</video>*/}
      <FieldsContainer />
      <FreeBetsWrapper />
      {!isMobile() && <TableUsersWinBets />}
      <LastResults />
      {/* <EuroSymbol /> */}
    </div>
  );
});

export default GameContent;
